import { atom } from 'recoil'
import { getRequest } from '/src/httpClient'
import { isBrowser } from '/src/util'

export const getStore = async () => {
  return await getRequest('/api/store', new AbortController())
}

export const userStoreState = atom({
  key: 'userStoreState',
  default: isBrowser ? getStore() : null
})

/*export const userStoreState = atom({
  key: 'userStoreState',
  default: null
})

export const userStoreQuery = selectorFamily({
  key: 'userStoreQuery',
  get: () => async () => {
    if (!isBrowser) return null
    return await getRequest('/api/store', new AbortController())
  },
})

export const userStoreSelector = selector({
  key: 'userStoreSelector',
  get: ({ get }) => {
    if (!isBrowser) return null
    return get(userStoreQuery(get(userStoreState)))
  }
})

export const useUserStore = () => {
  return useRecoilValue(userStoreSelector)
}*/